import Handler from "./handler";
import http from "../../../http";
import bindAll from "lodash.bindall";
import { getParamsFromQuery, sliceObject, getQuery } from "../xes-lib";
import { homeworkStatus, gotoHomeworkSuccess } from "../xes";

class HomeworkHandler extends Handler {
  constructor() {
    super()
    this.liveParams = getParamsFromQuery('all')
    if (!(getQuery('cannotEdit') === 'true')) {
      this.setStatus(homeworkStatus.REJECTED)
    }
    bindAll(this, [
      'getProjectData',
      'share',
      'save',
      'setStatus',
      'submit',
      'isHomeworkRejected'
    ])
  }
  // homework.jsx 中调用以设置随堂测到状态
  setStatus(status) {
    this.homeworkStatus = status
  }
  init(state, dispatch, data) {
  }
  getProjectData() {
    let id = getQuery('pid')
    if (id !== null) {
      return http.getProjectById(id)
    }
    return http.getLiveProject(this.liveParams)
  }
  share(projectMeta) {
    if (this.isHomeworkRejected()) {
      return this.save(projectMeta)
    }
    return Promise.resolve(projectMeta)
  }
  isHomeworkRejected() {
    return this.homeworkStatus === homeworkStatus.REJECTED
  }
  save(projectMeta) {
    return this.handleLockMethod(() => {
      let projectParams = sliceObject([
        "id",
        "version",
        "thumbnail",
        "xml",
        "original_id",
        "name"
      ], projectMeta)
      return http.saveLiveProject({...projectParams, ...this.liveParams})
    })
  }
  submit(projectMeta) {
    return this.handleLockMethod(() => {
      let projectParams = sliceObject([
        "id",
        "version",
        "thumbnail",
        "xml",
        "original_id",
        "name"
      ], projectMeta)
      
      return http.submitLiveProject({...projectParams, ...this.liveParams})
    })
  }
  onDoneSubmit(state, dispatch, data) {
    gotoHomeworkSuccess()
  }
  static getInstance() {
    if (HomeworkHandler.instance === null) {
      HomeworkHandler.instance = new HomeworkHandler()
    }
    return HomeworkHandler.instance
  }
}
HomeworkHandler.instance = null

export default HomeworkHandler